import React, { useRef, useState, useEffect } from 'react';
import { Card, Dropdown, DropdownButton } from 'react-bootstrap';
import { collection, onSnapshot, doc, setDoc, deleteDoc } from 'firebase/firestore';
import { firestore } from './../../FirebaseUtils';

function AdminVideoAssignmentCard(props) {
    const [ loading, setLoading ] = useState(true);
    const [ errorMessage, setErrorMessage ] = useState();

    const [locationData, setLocationData] = useState(null);
    const [selectedVideo, setSelectedVideo] = useState();
    const [selectedVideoName, setSelectedVideoName] = useState();

    useEffect(() => {
        const unsubscribe = onSnapshot(doc(firestore, 'videosSetup', props.location.id), (doc) => {
            setLocationData(doc.data());

            if (doc.data()) {
                setSelectedVideo(doc.data() ? doc.data().videoId : null);
                const element = props.videos.find((e) => e.id === doc.data().videoId);
                if (element) {
                    setSelectedVideoName(element.filename);
                }
            }
            else {
                setSelectedVideo(null);
                setSelectedVideoName(null);
            }

            setLoading(false);
        });
    
        // Cleanup the listener when the component unmounts
        return () => unsubscribe();
    }, []);
    
    // if (!locationData) {
    //     return <div>Loading...</div>;
    // }

    async function onSelectVideo(e) {
        console.log(e);
        
        let selectedVideo = "";

        // e is eventKey
        if (e != -1) {
            selectedVideo = props.videos[e].id;
        }
        else {
            setSelectedVideo(null);
            setSelectedVideoName(null);
        }

        const content = {
            videoId: selectedVideo
        };

        try {
            await setDoc(doc(firestore, "videosSetup", props.location.id), content);
        } 
        catch (error) {
            console.error('Error adding question:', error);
        }
    }

    return (
        <Card>
            <Card.Body>
                <Card.Title>
                    { props.location.id }: { props.location.description }
                </Card.Title>
                <Card.Text>
                    <div style={{ display: 'flex', flex: '1', flexDirection: 'row' }}>
                        <div>
                        {
                        loading ?
                            null
                        :
                            <DropdownButton title="เลือกวิดีโอ" onSelect={onSelectVideo}>
                                <Dropdown.Item eventKey={-1} key={`${props.location.id}_item_none`}>None</Dropdown.Item>
                                {
                                    props.videos.map((v, i) => {
                                        return (
                                            <Dropdown.Item eventKey={i} key={`${props.location.id}_item_${i}`}>{v.filename}</Dropdown.Item>
                                        );
                                    })
                                }
                            </DropdownButton>
                        }
                        </div>
                        <div className='ms-5'>
                            {
                                locationData === null ?
                                    null
                                :
                                    <span>{selectedVideo ? selectedVideo + ' = ' : "None" } {selectedVideoName ? selectedVideoName : null}</span>
                            }
                        </div>
                    </div>
                </Card.Text>
            </Card.Body>
        </Card>
    );
}

export default AdminVideoAssignmentCard;
